import React from 'react';
import { motion } from 'framer-motion'; // Framer Motion'dan motion import edilir.
import { imageVariants, textVariants, containerVariants } from '../../script/animationVariants'; // Animasyon varyantları
import { useTranslation } from 'react-i18next'; // useTranslation hook'u

const Section4 = () => {
  // useTranslation hook'u ile t fonksiyonunu alıyoruz.
  const { t } = useTranslation();

  return (
    <>
      {/* Vizyon ve Misyon Bölümü */}
      <motion.div 
        className="col-start-3 col-span-10 grid grid-cols-1 md:grid-cols-2 gap-20 mb-20"
        initial="hidden" 
        whileInView="visible" 
        variants={containerVariants} // Staggered animasyon için container varyantı
      >
        <motion.div variants={textVariants}>
          {/* Vizyon başlığı ve metni */}
          <h1 className="text-45 mb-5 font-light">{t('section4.vision.title')}</h1>
          <p className="text-20">
            {t('section4.vision.text')}
          </p>
        </motion.div>

        <motion.div variants={textVariants}>
          {/* Misyon başlığı ve metni */}
          <h1 className="text-45 mb-5 font-light">{t('section4.mission.title')}</h1>
          <p className="text-20">
            {t('section4.mission.text')}
          </p>
        </motion.div>
      </motion.div>

      {/* Kalite Politikamız Bölümü */}
      <motion.div 
        className="col-start-3 col-span-10 grid grid-cols-1  gap-20 mb-40"
        initial="hidden" 
        whileInView="visible" 
        variants={containerVariants}
      >
        {/* Sol tarafta kalite politikası banner resmi */}
   

        {/* Sağ tarafta kalite politikası metinleri */}
        <motion.div variants={textVariants}>
          <h1 className="text-45 mb-5 font-light">{t('section4.qualityPolicy.title')}</h1>
          <p className="text-20 mb-5">
            {t('section4.qualityPolicy.text1')}
          </p>
          <p className="text-20">
            {t('section4.qualityPolicy.text2')}
          </p>
        </motion.div>
      </motion.div>
    </>
  );
};

export default Section4;
